// extracted by mini-css-extract-plugin
export default {"cart-Widget-items":"CartWidgetList_cart-Widget-items__Ceyn6"};